import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, ModalBody } from 'reactstrap'
import { FiExternalLink, FiX } from 'react-icons/fi'
import './style.scss'

const formatUrl = (url) => {
  if (!url) return ''
  const trimmed = url.trim()
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed
  }
  return `https://${trimmed}`
}

export default function ModalExternalLink({
  isOpen,
  modal,
  toggle,
  onClose,
  extraFields
}) {
  const isVisible = isOpen ?? modal ?? false
  const handleClose = toggle || onClose

  const [copiedIndex, setCopiedIndex] = useState(null)

  const list = Array.isArray(extraFields?.list)
    ? extraFields.list
    : (Array.isArray(extraFields) ? extraFields : [])
  const isSafeLink = Boolean(extraFields?.enableSafeLinks)

  const handleOpenLink = (url) => {
    if (!url) return
    window.open(formatUrl(url), '_blank', 'noopener,noreferrer')
  }

  const handleCopy = (url, index) => {
    if (!url) return
    const formatted = formatUrl(url)
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(formatted)
    } else {
      const textarea = document.createElement('textarea')
      textarea.value = formatted
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
    }
    setCopiedIndex(index)
    setTimeout(() => {
      setCopiedIndex(null)
    }, 1500)
  }

  return (
    <Modal
      isOpen={isVisible}
      toggle={handleClose}
      centered
      className="modal-external-links"
    >
      <ModalBody className="p-0">
        <div className="modal-external-links__header">
          <span className="modal-external-links__title">Links</span>
          <button
            type="button"
            className="modal-external-links__close-btn"
            onClick={handleClose}
          >
            <FiX size={20} />
          </button>
        </div>

        <div className="modal-external-links__body">
          {list.length === 0 ? (
            <div className="modal-external-links__empty">No links available</div>
          ) : (
            list.map((item, index) => {
              if (isSafeLink) {
                return (
                  <div key={index} className="modal-external-links__item-safe">
                    <div className="modal-external-links__item-name">
                      {item.name}
                    </div>
                    <div className="modal-external-links__item-action-row">
                      <input
                        type="text"
                        readOnly
                        value={formatUrl(item.value)}
                        className="modal-external-links__url-input"
                      />
                      <button
                        type="button"
                        className="modal-external-links__copy-btn"
                        onClick={() => handleCopy(item.value, index)}
                      >
                        {copiedIndex === index ? 'Copied' : 'Copy'}
                      </button>
                      <button
                        type="button"
                        className="modal-external-links__open-btn"
                        onClick={() => handleOpenLink(item.value)}
                        title="Open Link"
                      >
                        <FiExternalLink size={16} />
                      </button>
                    </div>
                  </div>
                )
              }

              return (
                <div
                  key={index}
                  className="modal-external-links__item-card"
                  onClick={() => handleOpenLink(item.value)}
                >
                  <div className="modal-external-links__icon-box">
                    <FiExternalLink size={14} />
                  </div>
                  <div className="modal-external-links__item-content">
                    <div className="modal-external-links__item-title">
                      {item.name}
                    </div>
                    <div className="modal-external-links__item-url">
                      {formatUrl(item.value)}
                    </div>
                  </div>
                </div>
              )
            })
          )}
        </div>
      </ModalBody>
    </Modal>
  )
}

ModalExternalLink.propTypes = {
  isOpen: PropTypes.bool,
  modal: PropTypes.bool,
  toggle: PropTypes.func,
  onClose: PropTypes.func,
  extraFields: PropTypes.shape({
    list: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.string
      })
    ),
    enableSafeLinks: PropTypes.bool
  })
}
